import { render, staticRenderFns } from "./LoadingMessage.vue?vue&type=template&id=740e9b58&scoped=true"
import script from "./LoadingMessage.vue?vue&type=script&lang=js"
export * from "./LoadingMessage.vue?vue&type=script&lang=js"
import style0 from "./LoadingMessage.vue?vue&type=style&index=0&id=740e9b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e9b58",
  null
  
)

export default component.exports